import styled from "styled-components";
import { GrPlayFill } from "react-icons/gr";
import { MdInfoOutline } from "react-icons/md";
import { makeImagePath } from "../utils";
import { IBannerProps } from "../types";
import { useHistory } from "react-router-dom";

const BannerWrapper = styled.div<{ bgPhoto: string }>`
  height: 80vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 60px;
  background-image: linear-gradient(rgba(0, 0, 0, 0.2) 1%, rgba(0, 0, 0, 0)),
    linear-gradient(0.25turn, rgba(0, 0, 0, 0.9) 30%, rgba(0, 0, 0, 0)),
    linear-gradient(0deg, #141414, transparent 10%),
    url(${(props) => props.bgPhoto});
  background-size: cover;
`;

const Title = styled.h2`
  font-size: 40px;
  font-family: "Unbounded", cursive;
  margin-bottom: 20px;
`;

const Overview = styled.p`
  font-size: 20px;
  width: 40%;
  margin-bottom: 20px;
`;

const Buttons = styled.div`
  display: flex;
  flex-direction: row;
`;

const PlayButton = styled.button`
  background-color: rgba(255, 255, 255, 0.9);
  display: flex;
  justify-content: center;
  align-items: center;
  color: black;
  font-weight: 600;
  border: 0px;
  border-radius: 5px;
  padding: 10px 25px;
  margin-right: 12px;
  height: 48px;
  font-size: 19px;
  &:hover {
    cursor: not-allowed;
    background-color: rgba(255, 255, 255, 0.75);
  }
`;

const InfoButton = styled.button`
  background-color: rgba(109, 109, 110, 0.7);
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-weight: 600;
  border: 0px;
  border-radius: 5px;
  padding: 10px 25px;
  margin-right: 12px;
  height: 48px;
  font-size: 19px;
  &:hover {
    background-color: rgba(109, 109, 110, 0.4);
    cursor: pointer;
  }
`;

function Banner({
  setMediaId,
  category,
  id,
  imagePath,
  title,
  overview,
}: IBannerProps) {
  const history = useHistory();
  const onBoxClicked = (id: number) => {
    setMediaId(`${id}`);
    if (category === "movie") {
      history.push(`/movie/${id}`);
    } else {
      history.push(`/tv/${id}`);
    }
  };
  return (
    <BannerWrapper bgPhoto={makeImagePath(imagePath)}>
      <Title>{title}</Title>
      <Overview>{overview}</Overview>
      <Buttons>
        <PlayButton>
          {<GrPlayFill size={32} style={{ paddingRight: "10px" }} />} Play
        </PlayButton>
        <InfoButton
          onClick={() => {
            onBoxClicked(id);
          }}
        >
          {
            <MdInfoOutline
              size={40}
              color="white"
              style={{ paddingRight: "10px" }}
            />
          }{" "}
          More Info
        </InfoButton>
      </Buttons>
    </BannerWrapper>
  );
}

export default Banner;
